var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSalary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 11.6667C1.6665 8.52417 1.6665 6.9525 2.64317 5.97667C3.619 5 5.19067 5 8.33317 5H11.6665C14.809 5 16.3807 5 17.3565 5.97667C18.3332 6.9525 18.3332 8.52417 18.3332 11.6667C18.3332 14.8092 18.3332 16.3808 17.3565 17.3567C16.3807 18.3333 14.809 18.3333 11.6665 18.3333H8.33317C5.19067 18.3333 3.619 18.3333 2.64317 17.3567C1.6665 16.3808 1.6665 14.8092 1.6665 11.6667Z",
    stroke: "#252525",
    strokeOpacity: 0.4,
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.3332 5.00033C13.3332 3.42866 13.3332 2.64366 12.8448 2.15533C12.3565 1.66699 11.5715 1.66699 9.99984 1.66699C8.42817 1.66699 7.64317 1.66699 7.15484 2.15533C6.6665 2.64366 6.6665 3.42866 6.6665 5.00033",
    stroke: "#252525",
    strokeOpacity: 0.4,
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.99967 14.4448C10.9205 14.4448 11.6663 13.8232 11.6663 13.0565C11.6663 12.2898 10.9205 11.6673 9.99967 11.6673C9.07884 11.6673 8.33301 11.0457 8.33301 10.2782C8.33301 9.51148 9.07884 8.88982 9.99967 8.88982M9.99967 14.4448C9.07884 14.4448 8.33301 13.8232 8.33301 13.0565M9.99967 14.4448V15.0007M9.99967 8.88982V8.33398M9.99967 8.88982C10.9205 8.88982 11.6663 9.51148 11.6663 10.2782",
    stroke: "#252525",
    strokeOpacity: 0.4,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSalary);
export default __webpack_public_path__ + "static/media/ic-salary.b7e63f9df65133138ea4bcf428909d96.svg";
export { ForwardRef as ReactComponent };